export const state = (() => {
  let _email = "";
  let _name = "";
  let _partnerId = "";

  const email = () => _email;
  const partnerId = () => _partnerId;
  const name = () => _name;

  const saveToSession = (p: {
    email?: string;
    partnerId?: string;
    name?: string;
  }) => {
    const { email = "", name = "", partnerId = "cognni" } = p;
    _email = email;
    _partnerId = partnerId;
    _name = name;

    sessionStorage.setItem(
      "user",
      JSON.stringify({ email: email, partnerId: partnerId })
    );
  };

  const getSession = (id: string): { email: string; partnerId: string } => {
    if (!id) {
      return { email: _email, partnerId: _partnerId };
    }
    const defaultItem = { email: "", partnerId: "" };
    const item = sessionStorage.getItem(id);
    if (item) {
      try {
        return JSON.parse(item);
      } catch (e) {
        return defaultItem;
      }
    } else {
      return defaultItem;
    }
  };
  return {
    saveToSession,
    email,
    name,
    partnerId,
    getSession,
  };
})();
